import { Pipe, PipeTransform } from '@angular/core';
import { default as moment, Moment } from 'moment';

@Pipe({
  name: 'momentParseZonePipe',
  pure: true,
})
export class MomentParseZonePipe implements PipeTransform {
  constructor() {}

  transform(value: string, dateFormat: string): any {
    if (!value) return '';
    const momentDate = moment.parseZone(value);
    if (momentDate.isValid()) {
      return momentDate.format(dateFormat);
    }
    return '';
  }
}
